module.exports = __webpack_public_path__ + "bbeb54adf434e9b833dfcf3e6b852064.svg";